import React from 'react'
import './Tbl.css'

export default function TblRow({children, onClick}) {
  return (
    <div className='tblRow' onClick={onClick}>
      {children}
    </div>
  )
}
